module.exports = __webpack_public_path__ + "img/meitav-dash-present.e750b87a.svg";